import { render, staticRenderFns } from "./AlertSettingDetail.vue?vue&type=template&id=13936b1a&scoped=true"
import script from "./AlertSettingDetail.vue?vue&type=script&lang=js"
export * from "./AlertSettingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13936b1a",
  null
  
)

export default component.exports